import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { ValidationService } from '../../shared/providers/validation.service'
import { AuthenticationService } from '../../shared/auth/authentication.service'
import { PropertyListingService } from '../../shared/providers/property-listing.service'
import { LoaderService } from '../../shared/providers/loader.service'
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UserManagerService } from '../../shared/providers/user-manager.service'
import { Router, ActivatedRoute, Params } from '@angular/router';

enum Tabs {
  PortfolioContacts = 1,
  PropertyContacts = 2
}

@Component({
  selector: 'app-master-contact',
  templateUrl: './master-contact.component.html',
  styleUrls: ['./master-contact.component.css']
})
export class MasterContactComponent implements OnInit {
  currentMenu = '';
  constructor(private router: Router, private activatedRoute: ActivatedRoute, private UserManager: UserManagerService, public Validation: ValidationService, private modalService: BsModalService, private propertyListing: PropertyListingService, public authentication: AuthenticationService, private Loader: LoaderService) {
   
  }
  modalRefBOV: BsModalRef;
  user: any;
  tabs = Tabs;
  currentTab = Tabs.PortfolioContacts
  currentUser: any;
  @Input() UserGuid: string = '0000';
  ngOnInit() {
    this.UserGuid = this.UserGuid != '' ? this.UserGuid : '0000';
  }
  onTabClick(tab) {
    this.currentTab = tab;
  }
}
